// @flow
import React, { Component } from 'react'
import LabeledWrapper from './LabeledWrapper'
import { InputCell } from '../AudienceEdit'
import type { OptionType } from '../types'
import Select from '../controls/Select'

const t = {
  empty_option: 'Выберите шаблон',
  label: 'Шаблон названия'
}

type Props = {|
  options: Array<OptionType>,
  value: string,
  onChange: Function
|}

export default class AudienceNameTemplateSelect extends Component<Props> {
  render() {
    return (
      <div>
        <LabeledWrapper className="t-AudienceNameTemplateSelect" label={t.label} twoLines>
          <InputCell>
            <Select
              value={this.props.value}
              options={[{ id: null, name: t.empty_option }, ...this.props.options]}
              onChange={(value) => this.props.onChange(value)}
            />
          </InputCell>
        </LabeledWrapper>
      </div>
    )
  }
}
